// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"a12cee2a","481":"e412785c","886":"a2712be5","981":"2e0633f9"}[chunkId] + ".chunk.css";
};